<template>
    <div class="home" :style="isshowlogin?'height:100vh;overflow:hidden':''">
        <Header :isbig="true" ref="componenta" @changeLogin="changeLogin"></Header>
        <div class="homeCon">
            <div class="con-banner">
                <img src="https://img.zhangwenpindu.cn/img/home-banner.png" alt="logo" />
            </div>
            <div class="con-wrap">
                <div class="f30 text-333 con-title">精彩推荐</div>
                <div class="f18 text-666 con-text">提供正版小说阅读，海量网络小说</div>
                <div class="flexible jc-between book-wrap" @click="toDown">
                    <div v-for="item in shelfList">
                        <img :src="item.book.iconUrl" alt="">
                        <p class="f16 text-333 fwb-500 pt30">{{ item.book.name }}</p>
                        <p class="f14 text-666 pt10">{{ item.book.sort }}</p>
                    </div>
                </div>
            </div>
        </div>
        <Footer :big="true"></Footer>
        <Login @changeLogin="changeLogin" @getHeader="getHeader" v-if="isshowlogin"></Login>
    </div>
</template>

<script>
    import {
        homeShelfApi
    } from "@/api/book";
    import {
        getToken
    } from "../utils/storage";
    export default {
        name: "home",
        data() {
            return {
                shelfList: [],
            };
        },
        created() {
            this.gethomeShelf()
        },
        methods: {
            // 获取推荐位
            gethomeShelf() {
                let params = {
                    //pageId: '1693517103891484673' //dev
                    // pageId: '1699366053024542721' //prod
                    pageId: process.env.VUE_APP_CURRENTMODE == 'prod' ? '1699366053024542721' :
                        '1693517103891484673'
                }
                homeShelfApi(params).then(res => {
                    // console.log(res)
                    if (res.success) {
                        this.shelfList = res.data.shelves[0].content;
                    }
                });
            },
            goCreate() {
                this.$router.push('/author/create/0')
            },
            gofuli() {
                this.$router.push('/welfare')
            },
            toDown() {
                this.$router.push('/download')
            },
            getHeader() {
                this.$refs.componenta.getAccountList();
            }
        }
    };
</script>
<style lang="scss">
    .home {
        width: 100%;
        background: #fff;
        position: relative;

        .homeCon {
            .con-banner {
                img {
                    display: block;
                    width: 100%;
                }
            }

            .con-wrap {
                width: 1400px;
                margin: 0 auto;
                text-align: center;
                padding: 78px 0 120px;

                .con-title {
                    line-height: 42px;
                    padding-bottom: 14px;
                }

                .con-text {
                    line-height: 25px;
                    padding-bottom: 20px;
                }

                .book-wrap {
                    width: 100%;

                    div {
                        width: 214px;

                        img {
                            display: block;
                            width: 214px;
                            height: 298px;
                        }

                        p {
                            width: 214px;
                            text-align: left;
                            text-overflow: -o-ellipsis-lastline;
                            text-overflow: ellipsis;
                            display: -webkit-inline-box;
                            -webkit-line-clamp: 1;
                            line-clamp: 1;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                        }
                    }
                }

            }
        }
    }
</style>